<template>
  <div>
    <div class="search-bar-wrapper m-auto">
      <div
        :class="[isFocused ? '': '']"
        class="search-bar-inner-wrapper position-relative mt-20">

        <input
          ref="input"
          v-model="searchQuery"
          :class="[searchQuery!='' ? 'remove-focus': 'add-focus']"
          type="search"
          placeholder="Search"
          class="bm-input py-6 pe-32 ps-32 fs-14 rounded rounded-4 w-100"
          @keydown.enter.stop="changeQueryValue">
        <div
          :class="[isFocusedOut ? 'active-search':'']"
          class="search-icon position-absolute">
          <icon name="search"/>
        </div>
        <div
          :class="[searchQuery !='' ? 'd-block': 'd-none']"
          class="close-icon position-absolute"
          @click="clearValue($event)">
          <icon
            name="close-icon"
          />
        </div>
      </div>
    </div>

    <div
      :id="galleryImages == 'gallery' ? 'gallery-images':'stock-images'"
      class="thumbnail-box-conatiner mt-20">
      <Spinner
        v-show="loader"
        :speed="1"
        size="huge"
        message="Loading..."
        class="position-absolute inner-Loader"/>
      <div
        v-masonry
        :id="getMasonryId"
        class="image-container"
        transition-duration="0"
        item-selector=".image-wrapper"
        gutter="10" >

        <div
          v-masonry-tile
          v-for="(image, i) in getMyGalleryFilter"
          class="image-wrapper">
          <div
            :key="i"
            class="image-item">
            <div
              v-if="galleryImages == 'gallery'"
              :class="imageData.Id == image.Id ? 'd-block':''"
              class="image-delete-button"
              @click.stop="deleteImageFromMyGallery(image.Id)">
              <icon name = "trash"/>
            </div>
            <img
              ref="galleryVariable"
              :data-name="image.Name"
              :class="imageData.Id == image.Id ? 'thumbnail-border':''"
              :src="image.ImageThumbnailPathV2 && (image.ImageThumbnailPathV2.trim().endsWith('.svg')?image.DefaultImageUrl:(image.ImageThumbnailPathV2 ? image.ImageThumbnailPathV2:image.ImageThumbnailPathV2))"
              :id="i"
              :style="getStyle(image)"
              @click.stop="imageSelected(i)">
          </div>
        </div>
        <div
          :class="[imageData.length == 0 ? 'd-block' : 'd-none']"
          class="fs-15 text-danger fw-bold text-center">
          No Results Matched
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import EventBus from '@/EventBus';
import Spinner from 'vue-simple-spinner';

export default {
  name:       'ThumbnailBox',
  components: { Spinner },
  props:      {
    ImageTitle:    String,
    imageData:     Object,
    images:        { Object, Array },
    galleryImages: { type: String, default: 'null' },
    loader:        { default: false },
  },
  data() {
    return {
      searchQuery:  '',
      isFocused:    false,
      isFocusedOut: false,
    };
  },

  computed: {
    getMasonryId() {
      return this.galleryImages == 'gallery' ? 'gallery-masonry' : 'stock-masonry';
    },
    ImageName() {
      return `/img/${this.ImageTitle}.png`;
    },

    getMyGalleryFilter() {
      if (this.galleryImages == 'gallery') {
        if (this.searchQuery) {
          return this.images.filter(imageObject => imageObject.Name.toLowerCase().includes(this.searchQuery.toLowerCase()));
        }
        return this.images;
      }

      return this.images;
    },
  },

  methods: {
    getStyle(image) {
      let ratio = image.ImageThumbnailPathV2Height / image.ImageThumbnailPathV2Width;
      if (isNaN(ratio)) { ratio = 0.6; }
      return {
        backgroundColor: '#efefef',
        width:           '100%',
        height:          `calc(16vw * ${ratio})`,
      };
    },
    changeQueryValue(event) {
      this.searchQuery = event.target.value;
      if (this.galleryImages != 'gallery') {
        this.$emit('searchStockPhotos', this.searchQuery);
      }
    },
    /* imageSelected(index) {
      EventBus.$emit('onImageSelected', this.images[index], this.galleryImages);
    }, */
    imageSelected(index) {
      EventBus.$emit('onImageSelected', this.images[index]);
    },
    deleteImageFromMyGallery(id) {
      EventBus.$emit('ondeleteImageFromMyGallary', id);
    },
    handleModalClose() {
      this.$store.commit('setImageModel', false);
      this.isImageModalShown = !this.isImageModalShown;
    },

    clearValue() {
      this.searchQuery       = '';
      this.isFocused         = false;
      this.$refs.input.value = '';
      this.$emit('resetStockPhotosAfterSearch');
    },

    typeFocus() {
      debugger;
      if (this.searchQuery.length > 0) {
        this.isFocused = true;
      } else {
        this.isFocused = false;
      }
    },

    removeFocus() {
      this.isFocused = false;
    },

    focusIn() {
      this.isFocusedOut = true;
    },
  },
};

</script>
<style lang="scss" scoped>
  .custom-icon{
    width: auto !important;
  }
.thumbnail-box-conatiner{
  max-height: calc(100vh - 300px);
  overflow: auto;
  padding:0px 20px;

  .image-container{
    /*column-width: 14vw;
    grid-auto-flow: dense;*/
    margin-top: 10px;
    min-height: 412px;
    .image-wrapper{
      width:calc(25% - 10px);

    }
    .image-item{
      transition: all 0.2s;
      cursor: pointer;
      position: relative;
      &:hover{
        .image-delete-button{
          opacity: 1 !important;
        }
      }
      .image-delete-button {
        position: absolute;
        top: 10px;
        right: 10px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 3px;
        opacity: 0;
        height: 24px;
        width: 24px;
      }

      img {
        &:hover{
          box-shadow: 0 0 8px 4px rgba(0,0,0,0.2);
          opacity: 1;
        }
        width: 100%;
        margin-bottom: 10px;
        border-radius: 10px !important;
      }
      .thumbnail-border{
        border: 2px solid #3bb0fa!important
      }
    }


  }
  .inner-Loader {
    width: calc(100% - 80px);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 56;
    top: 210px;
    bottom: 2vh;

    .vue-simple-spinner-text{
      color: #52A7E1 !important
    }
  }
}


</style>
